import Vue from 'vue'
import VueRouter from 'vue-router'
// import Index from '../components/pages/index/index.vue'
// import Login from '../components/pages/login/index.vue'
// import Forgetpwd from '../components/pages/forgetpwd/index.vue'
// import Anonminer from '../components/pages/anonminer/index.vue'
// import test from '../components/pages/test/index.vue'
// import Block from '../components/pages/anonminer/block.vue'
Vue.use(VueRouter)
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}


const router = new VueRouter({
	mode: 'history',
	routes: [{
			path: '/',
			name: 'index',
			// component: Index,
			component:resolve =>require(['@/components/pages/index'],resolve),
			meta: {
				title: 'Star Map - 全球一站式挖礦綜合服務平台'
			}
		},
		{
			path: '/login',
			name: 'login',
			// component: Login,
			component:resolve =>require(['@/components/pages/login/'],resolve),
			meta: {
				title: 'Star Map - 登錄'
			}
		},
		{
			path: '/invite',
			name: 'invite',
			// component: Login,
			component:resolve =>require(['@/components/pages/login/'],resolve),
			meta: {
				title: 'Star Map - 邀請註冊'
			}
		},
		{
			path: '/forget',
			name: 'forget',
			// component: Forgetpwd,
			component:resolve =>require(['@/components/pages/forgetpwd/'],resolve),
			meta: {
				title: 'Star Map-忘記密碼'
			}
		},

		{
			path: '/miner',
			name: 'miner',
			// component: Anonminer,
			component:resolve =>require(['@/components/pages/anonminer'],resolve),
			meta: {
				title: 'Star Map-匿名礦工'
			}
		},
		{
			path: '/block',
			name: 'block',
			// component: Block,
			component:resolve =>require(['@/components/pages/block'],resolve),
			meta: {
				title: 'Star Map-區塊信息'
			}
		},
		{
			path: '/payments',
			name: 'payments',
			// component: Block,
			component:resolve =>require(['@/components/pages/paymenthistory'],resolve),
			meta: {
				title: 'Star Map-歷史記錄'
			}
		},
		{
			path: '/calc',
			name: 'calc',
			component:resolve =>require(['@/components/pages/pool/calc'],resolve),
			meta: {
				title: 'Star Map-收益計算'
			}
		},
		{
			path: '/help',
			name: 'help',
			component:resolve =>require(['@/components/pages/pool/help'],resolve),
			meta: {
				title: 'Star Map-幫助中心'
			}
		},
		{
			path: '/create',
			name: 'create',
			component:resolve =>require(['@/components/pages/pool/autominer'],resolve),
			meta: {
				title: 'Star Map-自助創建'
			}
		},
		{
			path: '/about',
			name: 'about',
			component:resolve =>require(['@/components/pages/pool/about'],resolve),
			meta: {
				title: 'Star Map-關於'
			}
		},
		{
			path: '/observer',
			name: 'observer',
			component:resolve =>require(['@/components/pages/labs/eth/observer.vue'],resolve),
			meta: {
				title: 'Star Map-ETH觀察者'
			}
		},
		{
			path: '/etcobserver',
			name: 'etcobserver',
			component:resolve =>require(['@/components/pages/labs/etc/observer.vue'],resolve),
			meta: {
				title: 'Star Map-ETC觀察者'
			}
		},
		{
			path: '/labs',
			name: 'labs',
			component:resolve =>require(['@/components/pages/labs/'],resolve),
			meta: {
				title: 'Star Map-創新區'
			},
			children:[
				
				{
					path:"/labs/eth-index",
					component:resolve =>require(['@/components/pages/labs/eth'],resolve),
					meta: {
						title: 'Star Map-ETH'
					},
					name:"eth-index"
				},
				{
					path:"/labs/etc-index",
					component:resolve =>require(['@/components/pages/labs/etc'],resolve),
					meta: {
						title: 'Star Map-ETC'
					},
					name:"etc-index"
				},
				{
					path:"/labs/course",
					component:resolve =>require(['@/components/pages/labs/help.vue'],resolve),
					meta: {
						title: 'Star Map-Miner-help'
					},
					name:"course"
				},
				{
					path:"/labs/course2",
					component:resolve =>require(['@/components/pages/labs/help2.vue'],resolve),
					meta: {
						title: 'Star Map-Miner-help'
					},
					name:"course2"
				},
				{
					path:"/labs/invite",
					component:resolve =>require(['@/components/pages/labs/invite.vue'],resolve),
					meta: {
						title: 'Star Map-Miner-invite'
					},
					name:"invite"
				},
				{
					path:"/labs/user",
					component:resolve =>require(['@/components/pages/labs/user.vue'],resolve),
					meta: {
						title: 'Star Map-Miner-userSetting'
					},
					name:"user"
				},
				{
					path:"/labs/noticelist",
					component:resolve =>require(['@/components/pages/labs/noticelist.vue'],resolve),
					meta: {
						title: 'Star Map-Miner-notice'
					},
					name:"noticelist"
				},
				{
					path:"/labs/notice",
					component:resolve =>require(['@/components/pages/labs/notice.vue'],resolve),
					meta: {
						title: 'Star Map-Miner-notice'
					},
					name:"notice"
				},
				{
					path:"/labs/*",
					redirect:'/labs',
					meta: {
						title: 'Star Map-創新區'
					}
				},
			]
		},
		// {
		// 	path: '/finance',
		// 	name: 'finance',
		// 	component:resolve =>require(['@/components/pages/finance/'],resolve),
		// 	meta: {
		// 		title: 'Star Map-創新區'
		// 	},
		// 	children:[
				
		// 		{
		// 			path:"/finance/wallet",
		// 			component:resolve =>require(['@/components/pages/finance/bata/index.vue'],resolve),
		// 			meta: {
		// 				title: 'Star Map-Wallet'
		// 			},
		// 			name:"Star Map-Wallet"
		// 		},{
		// 			path:"/finance/yubibao",
		// 			component:resolve =>require(['@/components/pages/finance/bata/index.vue'],resolve),
		// 			meta: {
		// 				title: 'Star Map-Wallet'
		// 			},
		// 			name:"Star Map-Wallet"
		// 		},{
		// 			path:"/finance/baoxian",
		// 			component:resolve =>require(['@/components/pages/finance/bata/index.vue'],resolve),
		// 			meta: {
		// 				title: 'Star Map-baoxian'
		// 			},
		// 			name:"Star Map-baoxian"
		// 		},{
		// 			path:"/finance/wange",
		// 			component:resolve =>require(['@/components/pages/finance/bata/index.vue'],resolve),
		// 			meta: {
		// 				title: 'Star Map-wange'
		// 			},
		// 			name:"Star Map-wange"
		// 		},{
		// 			path:"/finance/jiedai",
		// 			component:resolve =>require(['@/components/pages/finance/bata/index.vue'],resolve),
		// 			meta: {
		// 				title: 'Star Map-jiedai'
		// 			},
		// 			name:"Star Map-jiedai"
		// 		},{
		// 			path:"/finance/bilicai",
		// 			component:resolve =>require(['@/components/pages/finance/bata/index.vue'],resolve),
		// 			meta: {
		// 				title: 'Star Map-bilicai'
		// 			},
		// 			name:"Star Map-bilicai"
		// 		},
		// 		{
		// 			path:"/finance/*",
		// 			redirect:'/finance',
		// 			meta: {
		// 				title: 'Star Map-金融'
		// 			}
		// 		},
		// 	]
		// },
		{
			path: '/test',
			name: 'test',
			component:resolve =>require(['@/components/pages/test'],resolve),
			meta: {
				title: 'Star Map-創新區'
			}
		},
		// {
		// 	path:"/null",
		// 	redirect:'/labs/eth-index',
		// 	meta: {
		// 		title: '猫池 - 全球一站式挖矿综合服务平台'
		// 	}
		// },
		{
			path:"/*",
			redirect:'/',
			meta: {
				title: 'Star Map - 全球一站式挖礦綜合服務平台'
			}
		},
		
		
	]
})
router.beforeEach((to, from, next) => { //beforeEach是router的钩子函数，在进入路由前执行
	if (to.meta.title) { //判断是否有标题
		document.title = to.meta.title
	}
	next() //执行进入路由，如果不写就不会进入目标页
})
export default router
